<textarea #editorNode></textarea>